import {PropertyBase} from "./PropertyBase";
import 'select2';

export class SearchableDropDownProperty extends PropertyBase{
    public label:string="Field Type";
    public options:{label:string,value:string}[]=[];
    public optionGroups:OptionGroup[]=[];

    protected InternalGetElement(): JQuery {
        let $select:JQuery=jQuery(`<select class="form-control"></select>`);
        let selectedValue=this.GetOptionValue();
        for(let option of this.options) {
            let $option=jQuery(new Option(option.label,option.value,selectedValue));
            if(selectedValue==option.value)
                $option.attr('selected','selected')
            $select.append($option);
        }

        for(let optionGroup of this.optionGroups)
        {
            let $optGroup=jQuery('<optgroup></optgroup>').attr('label',optionGroup.GroupLabel);
            for(let option of optionGroup.options)
            {
                let $option=jQuery(new Option(option.label,option.value,selectedValue));
                if(selectedValue==option.value)
                    $option.attr('selected','selected')
                $optGroup.append($option);
            }
            $select.append($optGroup);
        }

        return $select;

    }

    public AddOptionGroup(optionGroup:OptionGroup):SearchableDropDownProperty{
        this.optionGroups.push(optionGroup);
        return this;
    }


    public AddOption(label:string,value:string)
    {
        this.options.push({
            value:value,
            label:label
        });
        return this;
    }

    protected InternalGenerationCompleted($element: JQuery) {
        let sorter=function(a, b) {
                                    let firstText=a.text.toLowerCase();
                                    let secondText=b.text.toLowerCase();
                                    if(firstText=='all')
                                        return -1;
                                    if(secondText=='all')
                                        return 1;
                                    return firstText < secondText ? -1 : firstText > secondText ? 1 : 0;
                                };
        $element.select2({
            sorter: function(data) {

                return data.sort(sorter);
            }
        });

        $element.change(()=>this.SetOptionValue($element.val()));
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }

}

export class OptionGroup{
    public options:{label:string,value:string}[]=[];

    constructor(public GroupLabel:string)
    {

    }

    public AddOption(label:string,value:string):OptionGroup{
        this.options.push({label:label,value:value})
        return this;
    }
}